import type { TOC } from '@ember/component/template-only';

import BillingPlansComponent from 'webapp/components/billing/plans';

const SettingsBillingPlansRouteTemplate: TOC<object> = <template>
	<div id="plans">
		<BillingPlansComponent />
	</div>
</template>;

export default SettingsBillingPlansRouteTemplate;
